module.exports = __webpack_public_path__ + "static/media/car.0f5f7a16.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/collectionOnline/images/car.png
// module id = 623
// module chunks = 0